module.exports = "<div class=\"NotFound\">\n  <h1>Oops...That page doesn’t exist.</h1>\n  <p>Looks like something got mixed up.</p>\n  <div class=\"NotFound-button\">\n    <a class=\"Button Button--large\" ui-sref=\"guides.landing\">Take me to homepage</a>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/not_found.html
// module id = 485
// module chunks = 24